import React, { Component } from "react";
import "./Guide.css";
// import EditableCell from '../components/EditableCell'
import {
    Row, Divider, Button, List
} from 'antd';

import { Link } from "react-router-dom";

export default class Guide extends Component {
    constructor(props) {
        super(props);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
    }

    next() {
        this.carousel.next();
    }
    previous() {
        this.carousel.prev();
    }

    componentDidMount() {
        try {
        } catch (e) {
            alert(e);
        }
    }

    render() {

        return <div className="Guide">
            <Row style={{ marginTop: "5vh" }} type="flex" justify="space-around">
                <h3 >The instructions of MACMA software</h3>
            </Row>
            <Divider />
            <List bordered>
                <List.Item>
                    <Link to={`/guide/basic`}>Basic</Link>
                </List.Item>
                {/* <List.Item>
                    <Link to={`/guide/mca`}>Multi-Criteria Analysis project</Link>
                </List.Item> */}
                <List.Item>
                    <Link to={`/guide/mamca`}>Multi-Actor Multi-Criteria Analysis project</Link>
                </List.Item>
                {/* <List.Item>
                    <Link to={`/guide/survey`}>Survey tool</Link>
                </List.Item> */}
            </List>
            {/* <Row type="flex" justify="space-around"  align="middle">
                <Col span={2}><Button type="primary" size="large" onClick={this.previous}><Icon type="caret-left" /></Button></Col>
                <Col span={20}>
                    <Carousel  ref={node => (this.carousel = node)}className="ant-carousel">
                        <div>
                            <img src={guide13} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide14} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide15} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide16} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide17} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide18} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide19} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide20} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide21} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide22} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide23} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide24} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide25} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide26} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide27} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide28} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide29} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide30} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide32} style={{ width: "100%" }} alt="guide" />
                        </div>
                    </Carousel>
                </Col>
                <Col span={2}><Button type="primary" size="large" onClick={this.next}><Icon type="caret-right" /></Button></Col>
            </Row> */}
            <Row style={{ marginTop: "5vh" }} type="flex" justify="space-around">
            <Button type="primary" size="large">
                    <a href="https://res.cloudinary.com/ddwpezn3f/image/upload/v1591264996/Homepage/MAMCA_software.pdf" target="_blank" rel="noopener noreferrer">MAMCA software paper</a>
                </Button>
                <Button type="primary" size="large">
                    <a href="https://res.cloudinary.com/ddwpezn3f/image/upload/v1725661444/Homepage/A_collaborative_group_decision-support_system_the_survey_based_multi-actor_multi-criteria_analysis_MAMCA_software.pdf" target="_blank" rel="noopener noreferrer">MAMCA survey extension paper</a>
                </Button>
                <Button type="primary" size="large">
                    <a href="mailto:info@mamca.eu">Contact us for more info!</a>
                </Button>
            </Row>
            {/* <Divider /> */}
        </div>;
    }
}
